//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "verify-company",
  data(){
    var validatePass2 = (rule, value, callback) => {
      let regExp = new RegExp("[\\u4E00-\\u9FFF]+","g");
      if (regExp.test(value)) {
        callback(new Error('请输入非中文字符'));
      } else {
        callback();
      }
    };
    return {
      verifyForm:{
        supplierName: '',
        countryId:null,
        vatCode:'',
        countryCode:'',
        countryName:''
      },
      verifyRules:{
        supplierName:[
          { required: true, message: '此字段必填', trigger: 'change' }
        ],
        countryId:[
          { required: true, message: '此字段必填', trigger: 'change' }
        ],
        vatCode:[
          { required: true, message: '此字段必填', trigger: 'change' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      countryList:[],
      checkName:false,
      checkCode:false
    }
  },
  methods:{
    //获取国家列表
    getCountryList(){
      this.$get('api/country/all?_allow_anonymous=true').then((data) => {
        this.countryList = data;
        for(let i = 0;i < this.countryList.length;i++){
          if(this.countryList[i].countryCode === this.$store.state.systemDefaultParam.country){
            if(!this.verifyForm.countryId){
              this.verifyForm.countryId = this.countryList[i].id;
            }
          }
          if(this.countryList[i].countryCode === 'CN'){
            this.$store.state.systemDefaultParam.chinaId = this.countryList[i].id;
          }
        }
      });
    },
  //  检查公司名称
    resetCheckName(){
      this.checkName = false;
    },
    checkSupplierName(){
      if(this.verifyForm.supplierName){
        this.$get('api/supplier/check-dup?_allow_anonymous=true',{checkFiled: 'name', checkValue: this.verifyForm.supplierName}).then((data) =>{
          this.checkName = data;
        })
      }else{
        this.checkName = false;
      }
    },
    // 检查统一社会信用代码
    checkVatCode(){
      if(this.verifyForm.vatCode){
        this.$get('api/supplier/check-dup?_allow_anonymous=true',{checkValue: this.verifyForm.vatCode, checkValue2: this.verifyForm.countryCode, checkFiled: 'vatCode'}).then((data) =>{
          this.checkCode = data;
        })
      }else{
        this.checkName = false;
      }
    },
  // 点击下一步
    next(){
      this.$refs['verifyForm'].validate((valid) => {
        if (valid) {
          for(let i = 0;i < this.countryList.length;i++){
            if(this.countryList[i].id = this.verifyForm.countryId){
              this.verifyForm.countryCode = this.countryList[i].countryCode;
              this.verifyForm.countryName = this.countryList[i].countryName;
              break;
            }
          }
          this.$loadingShow();
          this.$get('api/supplier/check-dup?_allow_anonymous=true',{checkFiled: 'name', checkValue: this.verifyForm.supplierName}).then((data) =>{
            this.checkName = data;
            if(!data){
              this.$get('api/supplier/check-dup?_allow_anonymous=true',{checkValue: this.verifyForm.vatCode, checkValue2: this.verifyForm.countryCode, checkFiled: 'vatCode'}).then((res) =>{
                this.$loadingHide();
                this.checkCode = res;
                if(!res){
                  this.$emit('next',3,this.verifyForm)
                }
              }).catch(() => {this.$loadingHide()});
            }
          }).catch(() => {
            this.$loadingHide();
          })
        } else {
          return false;
        }
      });
    },
    goBack(){
      this.$emit('next',1)
    }
  },
  mounted(){
    this.getCountryList();
    this.$eventHub.$on('sendInviteInfo',(res) =>{
      this.verifyForm.supplierName = res.name;
    });
  },
  destroyed() {
    this.$eventHub.$off('sendInviteInfo');
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/register/verify-company.vue